/** Link do evento pelo nome (slug); o id fica como reserva para eventos sem slug. */
export function eventPath(event: { slug?: string; id?: number }): string | number {
  return event.slug || event.id!;
}

/** Endereço completo para compartilhar: https://.../events/night-run-marco-zero */
export function eventShareUrl(event: { slug?: string; id?: number }): string {
  return `${window.location.origin}/events/${eventPath(event)}`;
}

/**
 * Link wa.me para o telefone do organizador (como vem do perfil: DDD + número) com a
 * mensagem já escrita. Null se o telefone não tiver formato válido.
 */
export function whatsAppLink(phone: string | undefined | null, message?: string): string | null {
  let digits = (phone ?? '').replace(/\D/g, '');
  if (digits.length === 10 || digits.length === 11) {
    digits = '55' + digits;
  }
  if (digits.length < 12 || digits.length > 15) {
    return null;
  }
  return `https://wa.me/${digits}` + (message ? `?text=${encodeURIComponent(message)}` : '');
}

/**
 * Destino do logo do patrocinador: o WhatsApp (com mensagem dizendo que veio da Radical Events,
 * e de qual evento, quando for o caso) ou, sem WhatsApp, o site.
 */
export function sponsorLink(sponsor: { whatsappPhone?: string | null; websiteUrl?: string | null },
                            eventTitle?: string): string | null {
  const message = eventTitle
    ? `Olá! Vi vocês como parceiros na página do evento "${eventTitle}" na Radical Events e gostaria de mais informações.`
    : 'Olá! Encontrei vocês entre os parceiros da Radical Events e gostaria de mais informações.';
  return whatsAppLink(sponsor.whatsappPhone, message) ?? sponsor.websiteUrl ?? null;
}
